import { h, Component } from 'preact';
import Button from '../button';
import style from './style';

class SearchButton extends Component {

  handleClick = () => {
    this.props.handleClick(this.props.id);
  }

  render({...props}) {

    const activeClass = this.props.isActive ? style['active'] : '';

    const myProps = {
      ...props,
      classes: props.classes.concat([style['button--search'], activeClass])
    };
    return (<Button {...myProps} handleClick={this.handleClick} />);
  }
};

export default SearchButton;
